<div class="dashboard-content-sec " id="user_edit">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

 

    <form (ngSubmit)="saveAuthKey()" [formGroup]="form">        

        <div class="row form-section">
            <div class="col">
                <div class="card">
                    <div class="card-title">
                        <h5 class="fa fa-user">
                            {{ this.title }}
                        </h5>
                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>                        
                    </div>

                    <div class="card-form">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>
    
                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>
            
                        <div class="form-row">
                            <label class="col-sm-2">Aud/Client Id</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Auth"
                                    name="Name" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="1" placeholder="">                                    
                            </div>
                            <div class="col-sm-1">
                                &nbsp;
                            </div>
                        </div>

                        <div *ngIf="AuthCtrl.invalid && (AuthCtrl.dirty || AuthCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="AuthCtrl.errors.required">
                              <span>Name is required.</span>
                           </div>
                           <div *ngIf="AuthCtrl.errors.minlength">
                              Name must be at least 2 characters long.
                           </div>
                        </div>

                        


                        <div class="form-row">
                            <label class="col-sm-2">Iss/Issuer</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Iss"
                                    name="Iss" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="1" placeholder="">                                    
                            </div>
                            <div class="col-sm-1">
                                &nbsp;
                            </div>
                        </div>

                        <div *ngIf="IssCtrl.invalid && (IssCtrl.dirty || IssCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="IssCtrl.errors.required">
                              <span>Name is required.</span>
                           </div>
                           <div *ngIf="IssCtrl.errors.minlength">
                              Name must be at least 2 characters long.
                           </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
      


